import React, { useEffect, useRef } from "react";
import useTitanApp from "@/hooks/useTitanApp";
import {
  setOpenPrescriptionDialog,
  setIncrementPrescriptionCompleted,
  setDynamicPrescriptions,
  setPrescriptionId,
  setIsPrescriptionUpdate,
  setSelectedPrescriptionCategory,
} from "@/dispatchers/patientDispatchers";

interface PrescriptionPrefillItem {
  medication: string;
  dosage: string;
  quantity: string;
  notes?: string;
  prescribedItemId?: string;
}

interface PrescriptionModalProps {
  trigger?: React.ReactNode;
  isDarkMode?: boolean;
  prefillItems?: PrescriptionPrefillItem[];
  allowedMedications?: any[];
  defaultCategory?: "pgd" | "pharmacy-first";
  lockedMedications?: boolean;
  onSave?: (prescription: any) => void;
}

/**
 * Bridges PathwayEngine's trigger+onSave interface to the existing
 * prescription modal that lives in PatientQuickActions (controlled
 * via Redux openPrescriptionDialog state).
 */
export function PrescriptionModal({
  trigger,
  prefillItems,
  defaultCategory,
  onSave,
}: PrescriptionModalProps) {
  const { patientState } = useTitanApp();
  const { prescriptionCompleted, dynamicPrescriptions } = patientState || {};

  const waitingForCompletion = useRef(false);

  useEffect(() => {
    if (waitingForCompletion.current && prescriptionCompleted) {
      waitingForCompletion.current = false;
      onSave?.({ items: dynamicPrescriptions || [] });
    }
  }, [prescriptionCompleted]);

  const handleClick = () => {
    setIncrementPrescriptionCompleted(false);
    waitingForCompletion.current = true;

    setPrescriptionId(null);
    setIsPrescriptionUpdate(false);
    setSelectedPrescriptionCategory(defaultCategory || "private");

    if (prefillItems && prefillItems.length > 0) {
      const mappedItems = prefillItems.map((item) => ({
        value: item.prescribedItemId ? item.medication : "",
        dose: item.dosage || "",
        quantity: item.quantity || "",
        notes: item.notes || "",
        prescribedItemId: item.prescribedItemId || "",
      }));
      setDynamicPrescriptions(mappedItems);
    } else {
      setDynamicPrescriptions([]);
    }

    setOpenPrescriptionDialog(true);
  };

  return (
    <div onClick={handleClick} style={{ display: "contents" }}>
      {trigger}
    </div>
  );
}
